<div class="modal-header">
    <h4 class="modal-title">Filter {{Title}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(true)"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12" *ngIf="ShowFilter.ShowBranch">
            <label for="BranchID" class="form-font-label">Branch<span class="text-danger">*</span></label>
            <ng-select name="BranchID" (change)="ApprovalComboLoad('Client')" [(ngModel)]="Filter.BranchID"
                #BranchID="ngModel" required>
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let Branch of Branchs"
                    [value]="Branch.BranchMasterID">{{Branch.BranchName}}</ng-option>
            </ng-select>
            <div class="invalid-feedback">
                Please select branch!
            </div>
        </div>

        <div class="col-md-12" *ngIf="ShowFilter.ShowClient">
            <label for="ClientID" class="form-font-label">Client<span class="text-danger">*</span></label>
            <ng-select name="ClientID" (change)="ApprovalComboLoad('Site')" [(ngModel)]="Filter.ClientID"
                #ClientID="ngModel" required>
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let Client of Clients"
                    [value]="Client.ClientGroupMasterID">{{Client.ClientGroupName}}</ng-option>
            </ng-select>
            <div class="invalid-feedback">
                Please select client!
            </div>
        </div>

        <div class="col-md-12" *ngIf="ShowFilter.ShowSite">
            <label for="SiteID" class="form-font-label">Site<span class="text-danger">*</span></label>
            <ng-select name="SiteID" [(ngModel)]="Filter.SiteID" #SiteID="ngModel" required>
                <ng-option [value]=0>All</ng-option>
                <ng-option *ngFor="let Site of Sites" [value]="Site.SiteMasterID">{{Site.SiteName}}</ng-option>
            </ng-select>
            <div class="invalid-feedback">
                Please select site!
            </div>
        </div>
    </div>
    <div class="row" *ngIf="ShowFilter.ShowSearchEmployee">
        <div class="col-md">
            <label for="SearchText" class="form-font-label">{{WebESSApplicabilityId == 8?'Empcode':WebESSApplicabilityId == 4?'Sitecode':''}}<span class="text-danger">*</span></label>
            <input class="form-control" placeholder="Search here" id="SearchText" name="SearchText"
                [(ngModel)]="Filter.SearchText" #SearchText="ngModel" required>
            <div class="invalid-feedback">
                Please enter empcode!
            </div>
        </div>
        <div class="col-auto" style="padding-top: 1.6rem;">
            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                (click)="search('Employee')"><i class="bi bi-search" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Search':'Loading...'}}</button>
        </div>
    </div>
    <div class="row mt-2" *ngIf="ShowFilter.ShowSearchEmployee">
        <ul class="list-group">
            @if(WebESSApplicabilityId == 8){
            @for (Employee of Employees; track Employee.EmpMasterID; let i = $index) {
            <li class="list-group-item">
                <div class="row">
                    <div class="col-3">{{Employee['EmpCode']}}</div>
                    <div class="col">{{Employee['FullName']}}</div>
                    <div class="col-auto"><i class="bi bi-trash deleteIcon" (click)="Delete('Employee',i)"></i></div>
                </div>
            </li>
            }
            }
            @else if(WebESSApplicabilityId == 4){
                @for (Employee of Employees; track Employee.SiteMasterID; let i = $index) {
                    <li class="list-group-item">
                        <div class="row">
                            <div class="col-3">{{Employee['SiteCode']}}</div>
                            <div class="col">{{Employee['SiteName']}}</div>
                            <div class="col-auto"><i class="bi bi-trash deleteIcon" (click)="Delete('Site',i)"></i></div>
                        </div>
                    </li>
                    }
            }
        </ul>
    </div>
</div>
<div class="modal-footer">

    <button *ngIf="WebESSApplicabilityId != 8" type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
        (click)="close(false)"><i class="bi bi-funnel" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Filter':'Loading...'}}</button>

    <button *ngIf="(WebESSApplicabilityId == 8 || WebESSApplicabilityId == 4) && ShowSample" class="btn btn-sm btn-primary"
        name="sample" (click)="downloadExcel()">
        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Sample':'Loading...'}}
    </button>

    <label *ngIf="(WebESSApplicabilityId == 8 || WebESSApplicabilityId == 4) && ShowUpload" for="file-upload"
        class="btn btn-sm btn-primary">
        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled ? 'Upload' : 'Loading...'}}
    </label>
    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)" accept=".xls,.xlsx">

    <button *ngIf="WebESSApplicabilityId == 8 || WebESSApplicabilityId == 4" type="button"
        class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="ok()"><i class="bi bi-check"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Add':'Loading...'}}</button>

    <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="isDisabled" (click)="close(true)"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>

</div>